import { updateItems } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1024px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block text-xs font-medium text-primary-600 bg-primary-100/70 px-3 py-1 rounded-full mb-3">
            实时动态
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">最新爆料快讯</h2>
          <p className="text-sm text-foreground-600 mt-2">7×24小时滚动更新，第一时间获取全网最新爆料</p>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-5 top-0 bottom-0 w-0.5 bg-background-200"></div>

          <div className="space-y-5">
            {updateItems.map((item, i) => (
              <div key={i} className="relative flex items-start gap-4 md:gap-6 pl-10 md:pl-12">
                <div className={`absolute left-[11px] md:left-[15px] w-2.5 h-2.5 rounded-full border-2 border-background-50 ${
                  i === 0 ? 'bg-primary-500' : i < 3 ? 'bg-accent-500' : 'bg-background-300'
                }`}></div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                    <span className={`text-[10px] font-semibold px-1.5 py-0.5 rounded whitespace-nowrap ${
                      item.tag === '最新' ? 'bg-primary-100 text-primary-700' :
                      item.tag === '快讯' ? 'bg-accent-100 text-accent-700' :
                      'bg-secondary-100 text-secondary-700'
                    }`}>
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-sm md:text-base text-foreground-800 leading-relaxed">{item.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}